<template> 
	<div class="compare-block compare-text-infor">
		<h4 class="title compare-block-title pdx-3">
			<i class="title-icon title-icon3"></i>经营状况</h4>
	<!-- <div class="compare-view-scroll compare-text-infor"> -->
		<table  border="0" cellspacing="0" cellpadding="0"  width="100%">
				<tr class="compare-view">
			<td class="a-compare-company left-sticky">
				<h5 class="fz16 title pdx-3">营业收入</h5>
			</td>
			<td class="a-compare-company" :key="i" v-for="(list,i) in compareList">
				<span class="pdx-3">{{list.data.revenue.year+'年'+list.data.revenue.name}}:{{list.data.revenue.data}}</span>
			</td> 
			<td class="a-compare-company"  v-for="(item,index) in  5-compareList.length" :key="index+10">-</td>
		</tr>
		<tr class="compare-view compare-text-infor">
			<td class="a-compare-company left-sticky">
				<h5 class="fz16 title pdx-3">净利润</h5>
			</td>
			<td class="a-compare-company" :key="i" v-for="(list,i) in compareList">
				<span class="pdx-3">{{list.data.profit.year+'年'+list.data.profit.name}}:{{list.data.profit.data}}</span>
			</td> 
			<td class="a-compare-company"  v-for="(item,index) in  5-compareList.length" :key="index+10">-</td>
		</tr> 
		</table>
	<!-- </div> --> 
	</div> 
</template>

<script>
export default {
		name: 'compare-jyzk',
		data(){return{ 
			userdata:{},
		}},
		props:{
			compareList:{type:Array},
			refreshNum:{type:Number,default:1}
		}
		
		
}
</script>

<style>
</style>